var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.recordList),function(record,recordIndex){return _c('LvChecklistCollapseList',{key:recordIndex,staticClass:"w-full",attrs:{"record-data":record,"title":'YYYY',"sub-title":'2022. Q5 (11-1)'}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }